



















































import {Component, Mixins, Prop} from 'vue-property-decorator';
import RecipientMethods from '@/mixins/RecipientMethods.vue';
import TargetedRecipientListModal from '@/components/Admin/Modals/TargetedRecipientListModal.vue';

@Component({
  components: {TargetedRecipientListModal},
})
export default class Recipients extends Mixins(RecipientMethods) {
  @Prop({default: ''}) public label: any;
  @Prop({default: []}) public recipients: any;
  @Prop({default: true}) public allowDelete: boolean;
  @Prop({default: true}) public allowAdd: boolean;
  @Prop({default: true}) public fromCachedTargets: boolean;
  @Prop({default: false}) public isInvalid: boolean;
  @Prop({default: false}) public isCreating: boolean;
}
